import * as React from "react";
import { observer } from "mobx-react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkEmptyState } from "uitk-react-empty-state";
import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n.ts";
import { LOBState, PackageWizardState } from "src/stores/wizard/state";
import { Experiment, isVariantEnabled } from "src/components/utility/experiment";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export interface PackageErrorStateProps {
  lobsMissing: number;
  packageWizardState: PackageWizardState;
  lobState: LOBState;
  context?: ExtendedContextStore;
}

const { lobErrorHeadingsMap, lobErrorBodyMap, lobErrorHeadingsMapMultiLOB, lobErrorBodyMapMultiLOB } = locKeys;

export const PackageErrorState: React.FunctionComponent<PackageErrorStateProps> = observer(
  ({ context, lobsMissing, packageWizardState, lobState }) => {
    const { PWA_Package_Wizard_Multi_LOB } = Experiment;
    const { formatText } = useLocalization();
    const isMultiLOBWizardEnabled = isVariantEnabled(context, PWA_Package_Wizard_Multi_LOB);

    const heading = formatText(
      isMultiLOBWizardEnabled ? lobErrorHeadingsMapMultiLOB[lobsMissing] : lobErrorHeadingsMap[lobsMissing]
    );
    let body = formatText(
      isMultiLOBWizardEnabled ? lobErrorBodyMapMultiLOB[lobsMissing] : lobErrorBodyMap[lobsMissing]
    );
    const { updateInvalidFormsState } = packageWizardState;

    body = lobsMissing === 99 ? formatText(lobState.config.heading.lobNotSupported) : body;

    updateInvalidFormsState();

    return (
      <UitkLayoutGridItem colSpan="all">
        <UitkEmptyState icon="search" heading={heading} body={body} headingLevel="h2" />
      </UitkLayoutGridItem>
    );
  }
);
